/**
 * @generated SignedSource<<bfcf3f36862f6894c3ddefc948c1aec5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BuyComputeCreditsInput = {
  amountOfCredits: string;
  clientMutationId: string;
  ownerUid: string;
  paymentTokenId: string;
  platform: string;
  receiptEmail?: string | null;
};
export type ComputeCreditsStripeDialogMutation$variables = {
  input: BuyComputeCreditsInput;
};
export type ComputeCreditsStripeDialogMutation$data = {
  readonly buyComputeCredits: {
    readonly error: string | null;
    readonly info: {
      readonly balanceInCredits: string;
      readonly uid: string;
    };
  };
};
export type ComputeCreditsStripeDialogMutation = {
  response: ComputeCreditsStripeDialogMutation$data;
  variables: ComputeCreditsStripeDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BuyComputeCreditsPayload",
    "kind": "LinkedField",
    "name": "buyComputeCredits",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "OwnerInfo",
        "kind": "LinkedField",
        "name": "info",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "balanceInCredits",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ComputeCreditsStripeDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ComputeCreditsStripeDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e03fe3f3012243e1939a033c08b420ff",
    "id": null,
    "metadata": {},
    "name": "ComputeCreditsStripeDialogMutation",
    "operationKind": "mutation",
    "text": "mutation ComputeCreditsStripeDialogMutation(\n  $input: BuyComputeCreditsInput!\n) {\n  buyComputeCredits(input: $input) {\n    error\n    info {\n      uid\n      balanceInCredits\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "737ce5e1a63d2b925f24325b186fd8e4";

export default node;
